const success = 'success';
const inprogress = 'in-progress';
const failed = 'failed';
const processed = 'processed';

const SocketNotificationStatus = {
  success,
  inprogress,
  failed,
  processed,
};

export default SocketNotificationStatus;
